import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

export const languageInterceptor: HttpInterceptorFn = (request, next) => {
    const translateService = inject(TranslateService);

    return next(
        request.clone({
            headers: request.headers.set("Accept-Language", translateService.defaultLang ?? "fr")
        })
    );
};
